/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlReportedAssetResponse } from './ControlReportedAssetResponse';
import {
    ControlReportedAssetResponseFromJSON,
    ControlReportedAssetResponseFromJSONTyped,
    ControlReportedAssetResponseToJSON,
} from './ControlReportedAssetResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedReportedAssetResponse
 */
export interface ControlPaginatedReportedAssetResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedReportedAssetResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedReportedAssetResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedReportedAssetResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlReportedAssetResponse>}
     * @memberof ControlPaginatedReportedAssetResponse
     */
    results: Array<ControlReportedAssetResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedReportedAssetResponse interface.
 */
export function instanceOfControlPaginatedReportedAssetResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedReportedAssetResponseFromJSON(json: any): ControlPaginatedReportedAssetResponse {
    return ControlPaginatedReportedAssetResponseFromJSONTyped(json, false);
}

export function ControlPaginatedReportedAssetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedReportedAssetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlReportedAssetResponseFromJSON)),
    };
}

export function ControlPaginatedReportedAssetResponseToJSON(value?: ControlPaginatedReportedAssetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlReportedAssetResponseToJSON)),
    };
}

